/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import { FC } from 'react';

import { EConstructorReportsNew } from '@/main/pages/PageReportsConstructor/constants';

import { WizardReportConstructorStepStyled } from '../../components/styled/WizardReportConstructorStyled';
import WizardColumnsSelection from '../../components/WizardColumnsSelection';
import { mockReportColumns } from '../../mock';
import { IWizardOrderReportLocationData } from '../types';


interface IWizardOrderReportSelectionDataStep {
    reportData: IWizardOrderReportLocationData;
}

const WizardOrderReportSelectionDataStep: FC<IWizardOrderReportSelectionDataStep> = ({ reportData }) => {
    const { report } = reportData;

    return (
        <WizardReportConstructorStepStyled>
            {report.reportType === EConstructorReportsNew.REPORT_CUSTOM_SUBSCRIBERS && (
                <WizardColumnsSelection reportColumns={mockReportColumns} title="Столбцы в файле отчета" />
            )}
        </WizardReportConstructorStepStyled>
    );
};

export default WizardOrderReportSelectionDataStep;
